export default {
    //left a commented out entry here to make it easier to remember how to add one now that this file is empty
    //testName: {
    //    experimentId: "7",
    //    variationId: "2"
    //}
};